<template>
  <div id="pageDeclaration">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
          <v-flex sm12 md12 lg8>
            <v-widget title="Nội dung chi tiết">
            <template slot="widget-content">
              <v-layout row wrap>
                <v-flex lg6 md6 sm12>
                  <v-text-field label="Mã Đơn Hàng" v-model="currentDeclaration.OrderID" class="input-group--focused" disabled></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                  <v-text-field label="Mã KB" v-model="currentDeclaration.MaKB" class="input-group--focused" disabled></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12 v-if="false">
                  <v-text-field label="Mã HS" v-model="currentDeclaration.MaHS" class="input-group--focused" :disabled="isLocked && !adminRole"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12 v-if="false">
                  <v-text-field label="Nguồn" v-model="currentDeclaration.Nguon" class="input-group--focused" :disabled="isLocked && !adminRole"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12 v-if="false">
                  <v-text-field label="Consignee" v-model="currentDeclaration.Consignee" class="input-group--focused" :disabled="isLocked && !adminRole"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                  <v-text-field label="Thương hiệu" :value="getDeclarationField(['ThuongHieu', 'Brand'])" class="input-group--focused" :disabled="isLocked && !adminRole" @input="setDeclarationField(['ThuongHieu', 'Brand'], $event)"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                  <v-text-field label="HSCODE" :value="getDeclarationField(['MaHS', 'HSCODE', 'HSCode'])" class="input-group--focused" :disabled="isLocked && !adminRole" @input="setDeclarationField(['MaHS', 'HSCODE', 'HSCode'], $event)"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                  <v-text-field label="Đơn vị tính" v-model="currentDeclaration.DonViTinh" class="input-group--focused" :disabled="isLocked && !adminRole"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                  <h-currency-input label="Số kiện" :value="getDeclarationField(['SoKien', 'PackageCount'])" :decimal="0" class="input-group--focused" :disabled="isLocked && !adminRole" @input="setDeclarationField(['SoKien', 'PackageCount'], $event)"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12>
                  <v-text-field label="Tên nhà cung cấp" :value="getDeclarationField(['TenNhaCungCap', 'NhaCungCap', 'SupplierName'])" class="input-group--focused" :disabled="isLocked && !adminRole" @input="setDeclarationField(['TenNhaCungCap', 'NhaCungCap', 'SupplierName'], $event)"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12>
                  <h-currency-input label="Đơn giá dự kiến" v-model="currentDeclaration.GiaKhaiHQToiThieu" :decimal="0" class="input-group--focused" :disabled="isLocked && !adminRole"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12>
                  <h-currency-input label="Số lượng" v-model="currentDeclaration.SoLuong" :decimal="0" class="input-group--focused" :disabled="isLocked && !adminRole"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12>
                  <h-currency-input label="Thuế NK (%)" v-model="currentDeclaration.ThueNK" :decimal="2" class="input-group--focused" :disabled="isLocked && !adminRole"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12>
                  <h-currency-input label="Thuế VAT (%)" v-model="currentDeclaration.ThueVAT" :decimal="2" class="input-group--focused" :disabled="isLocked && !adminRole"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12 v-if="false">
                  <h-currency-input label="Thuế TTĐB (%)" v-model="currentDeclaration.ThueTTDB" :decimal="2" class="input-group--focused" :disabled="isLocked && !adminRole"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12 v-if="false">
                  <h-currency-input label="Thuế tự vệ (%)" v-model="currentDeclaration.ThueTuVe" :decimal="2" class="input-group--focused" :disabled="isLocked && !adminRole"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12 v-if="false">
                  <h-currency-input label="Thuế môi trường (%)" v-model="currentDeclaration.ThueMoiTruong" :decimal="2" class="input-group--focused" :disabled="isLocked && !adminRole"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12 v-if="false">
                  <v-text-field label="CS nhập khẩu" v-model="currentDeclaration.ChinhSachNhapKhau" class="input-group--focused" :disabled="isLocked && !adminRole"></v-text-field>
                </v-flex>
                <v-flex lg6 md6 sm12 v-if="false">
                  <v-text-field label="Chi phí chuyên ngành" v-model="currentDeclaration.ChiPhiChuyenNganh" class="input-group--focused" :disabled="isLocked && !adminRole"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                  <v-text-field label="Link google drive ảnh" :value="getDeclarationField(['LinkGoogleDrive', 'GoogleDriveLink', 'GoogleDrive'])" class="input-group--focused" :disabled="isLocked && !adminRole" @input="setDeclarationField(['LinkGoogleDrive', 'GoogleDriveLink', 'GoogleDrive'], $event)"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                  <v-text-field label="Hình ảnh hàng hóa (URL)" v-model="currentDeclaration.HinhAnh" class="input-group--focused" :disabled="isLocked && !adminRole"></v-text-field>
                  <input type="file" ref="r2Uploader" style="display: none" @change="uploadR2Image" accept="image/*,.pdf,.doc,.docx,.xls,.xlsx" />
                  <v-btn small color="primary" @click="$refs.r2Uploader.click()" :loading="uploadingR2" :disabled="isLocked && !adminRole" class="mt-2">
                    <v-icon left>cloud_upload</v-icon> Tải file lên
                  </v-btn>
                </v-flex>
                <v-flex lg12 md12 sm12>
                  <a :href="currentDeclaration.HinhAnh" target="_blank" class="mr-2">
                    <img v-if="currentDeclaration.HinhAnh && currentDeclaration.HinhAnh.match(/\.(jpeg|jpg|gif|png)$/)" :src="currentDeclaration.HinhAnh" style="max-height: 200px" />
                    <span v-else>Xem file đính kèm</span>
                  </a>
                </v-flex>
                <v-flex lg12 md12 sm12>
                  <v-textarea label="Mô tả" v-model="currentDeclaration.MoTa" class="input-group--focused" :disabled="isLocked && !adminRole"></v-textarea>
                </v-flex>

                <v-flex lg12 md12 sm12 v-if="false">
                  <v-select
                    :disabled="isLocked && !adminRole"
                    v-model="editStatus"
                    :items="declaration_status_list"
                    item-text="name"
                    item-value="value"
                    label="Trạng thái"
                  ></v-select>
                </v-flex>
                <v-layout class="d-flex">
                    <v-flex lg12>
                        <v-btn class="align-right" color="#dc3545" dark @click="saveData" :disabled="isLocked && !adminRole">
                            Lưu lại
                        </v-btn>
                    </v-flex>
                </v-layout>
              </v-layout>
            </template>
            </v-widget>

            <v-widget title="Nhật ký chỉnh sửa" class="mt-3">
              <template slot="widget-content">
                <div v-if="editLogs && editLogs.length > 0" class="log-container">
                  <div
                    v-for="(log, idx) in editLogs"
                    :key="idx"
                    class="log-item py-2 px-3 mb-2"
                  >
                    <div class="d-flex justify-space-between align-center">
                      <span class="font-weight-bold blue--text">{{ log.Username }}</span>
                      <span class="caption grey--text">{{ formatLogDate(log.CreatedDate) }}</span>
                    </div>
                    <div class="mt-1 body-2 text-pre-line text-slate-800">{{ log.HistoryContent }}</div>
                  </div>
                </div>
                <div v-else-if="loadingLogs" class="text-center py-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
                <div v-else class="text-center grey--text py-4">
                  Chưa có lịch sử chỉnh sửa
                </div>
              </template>
            </v-widget>
          </v-flex>
          <v-flex sm12 md12 lg4>
                <v-widget title="Chat box">
                    <div slot="widget-content">
                        <message-box :orderId="Number(declarationId)" :orderType="6"></message-box>
                    </div>
                </v-widget>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import VWidget from "@/components/VWidget";
import MessageBox from "@/components/chat/MessageBox";
export default {
  components: {
    VWidget,
    MessageBox
  },
  data() {
    return {
      declaration_status: configs.DECLARATION_STATUS,
      declaration_status_list: configs.DECLARE_STATUS_LIST,
      editStatus: 1,
      uploadingR2: false,
      editLogs: [],
      loadingLogs: false,
    };
  },
  computed: {
    ...mapState("declaration", {
      loading: "loading",
      currentDeclaration: "selected"
    }),
    declarationId() {
      return this.$route.params.Pid;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.InteralControl) == configs.ROLE_TYPE.InteralControl;
    },
    isLocked() {
      return this.currentDeclaration.Status === this.declaration_status.Locked;
    }
  },
  watch: {
    currentDeclaration() {
      this.editStatus = this.currentDeclaration.Status || 1;
    }
  },
  methods: {
    getDeclarationField(keys) {
      const matchedKey = keys.find(key => this.currentDeclaration[key] !== undefined && this.currentDeclaration[key] !== null);
      return matchedKey ? this.currentDeclaration[matchedKey] : "";
    },
    setDeclarationField(keys, value) {
      const matchedKey = keys.find(key => Object.prototype.hasOwnProperty.call(this.currentDeclaration, key));
      const targetKey = matchedKey || keys[0];
      this.$set(this.currentDeclaration, targetKey, value);
    },
    refreshData() {
      if (this.declarationId > 0) {
        this.$store.dispatch("declaration/getDetail", this.declarationId);
        this.fetchEditLogs();
      }
    },
    fetchEditLogs() {
      if (!this.declarationId) return;
      this.loadingLogs = true;
      this.$http.get(`${configs.API || ""}/admin/api/changedhistory/?orderId=${this.declarationId}&orderType=6`, {
        headers: { "Authorization": "Bearer " + this.$store.state.authentication.token }
      }).then(res => {
        this.loadingLogs = false;
        if (res.data && res.data.data) {
          this.editLogs = res.data.data;
        }
      }).catch(err => {
        this.loadingLogs = false;
        /* eslint-disable-next-line no-console */
        console.error("Lỗi khi tải nhật ký chỉnh sửa", err);
      });
    },
    formatLogDate(val) {
      if (!val) return "";
      try {
        const date = new Date(val);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}`;
      } catch (e) {
        return val;
      }
    },
    uploadR2Image(e) {
      let file = e.target.files[0];
      if (!file) return;
      this.uploadingR2 = true;
      let formData = new FormData();
      formData.append('file', file);
      this.$http.post(`${configs.API || ''}/admin/api/upload/r2/`, formData, {
          headers: { "Authorization": "Bearer " + this.$store.state.authentication.token }
      }).then(res => {
          this.uploadingR2 = false;
          if (res.data.status === 200 && res.data.data && res.data.data.url) {
              this.currentDeclaration.HinhAnh = res.data.data.url;
          } else {
              window.getApp.$emit('SHOW_NOTICE', "Upload thất bại: " + (res.data.message || res.data.error || ''), 'error');
          }
      }).catch(err => {
          this.uploadingR2 = false;
          window.getApp.$emit('SHOW_NOTICE', "Lỗi kết nối khi upload ảnh.", 'error');
      });
      this.$refs.r2Uploader.value = '';
    },
    saveData() {
      this.currentDeclaration.Status = this.editStatus;
      this.$store.dispatch("declaration/setDetail", { data: this.currentDeclaration, id: this.currentDeclaration.ID });
    }
  },
  mounted() {
    this.refreshData();
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.refreshData);
  }
};
</script>

<style scoped>
.align-right{
  float: right;
  margin: 5px;
}
.log-item {
  border-left: 3px solid #1976d2;
  background-color: #f5f5f5;
  border-radius: 0 4px 4px 0;
}
.text-pre-line {
  white-space: pre-line;
}
</style>
